import { BaseIp, ProIp } from "./ApiURL";


//Post mapping
export const userLoginAPI = ProIp + "userLoginAPI"

//(POST) http://localhost:8087/digital-library/userLoginAPI/mob
export const userLoginNewAPI = ProIp + "userLoginAPI/mob"
